import {
  FreeWithPuzzlePro,
  HStack,
  PaidByPuzzle,
  PaidByPuzzlePro,
  Skeleton,
  Text,
  VStack,
} from 'ui_2';
import { useFeeQuery } from '@puzzlehq/frontend-utils';

type Props = {
  onGetProClicked?: () => void;
};

export const FeeView = ({ onGetProClicked }: Props) => {
  const feeQuery = useFeeQuery({
    programId: import.meta.env.VITE_MYSTERY_CITY_CONTRACT!,
    functionId: 'submit_game',
    network: import.meta.env.VITE_NETWORK!,
  });

  const coverageType = feeQuery.data?.feeCoverageType;
  const fee = feeQuery.data?.fee?.fee.total;
  const covered = feeQuery.data?.covered;

  return (
    <HStack className='w-full max-w-[300px] rounded-[10px] bg-[#13252c] px-4 py-2'>
      <Text family='space' color='aqua'>
        Fee
      </Text>
      <HStack className='flex-grow' />
      <VStack className='justify-end'>
        {(() => {
          if (coverageType === 'all') {
            return <PaidByPuzzle fontColor='white' />;
          } else if (fee === undefined) {
            return <Skeleton className='h-4 w-12' />;
          } else {
            return (
              <VStack className='text-right'>
                <Text
                  family='space'
                  color='aqua'
                  className={`${
                    coverageType === 'pro' && covered ? 'line-through' : ''
                  }`}
                >
                  {fee} ALEO
                </Text>
                {coverageType === 'pro' && covered && (
                  <PaidByPuzzlePro fontFamily='space' fontColor='aqua' />
                )}
                {coverageType === 'pro' && !covered && (
                  <FreeWithPuzzlePro
                    fontColor='aqua'
                    fontFamily='space'
                    onGetProClicked={onGetProClicked}
                  />
                )}
              </VStack>
            );
          }
        })()}
      </VStack>
    </HStack>
  );
};

export const FeeViewBanner = ({ onGetProClicked }: Props) => {
  const feeQuery = useFeeQuery({
    programId: import.meta.env.VITE_MYSTERY_CITY_CONTRACT!,
    functionId: 'submit_game',
    network: import.meta.env.VITE_NETWORK!,
  });

  const coverageType = feeQuery.data?.feeCoverageType;
  const fee = feeQuery.data?.fee?.fee.total;
  const covered = feeQuery.data?.covered;

  return (
    <HStack className='w-full bg-[#13252c] px-4 py-2'>
      <Text family='space' color='aqua'>
        Fee
      </Text>
      <HStack className='flex-grow' />
      <VStack className='justify-end'>
        {(() => {
          if (coverageType === 'all') {
            return <PaidByPuzzle fontColor='white' />;
          } else if (fee === undefined) {
            return <Skeleton className='h-4 w-12' />;
          } else {
            return (
              <VStack className='text-right'>
                <Text
                  family='space'
                  color='aqua'
                  className={`${
                    coverageType === 'pro' && covered ? 'line-through' : ''
                  }`}
                >
                  {fee} ALEO
                </Text>
                {coverageType === 'pro' && covered && (
                  <PaidByPuzzlePro fontFamily='space' fontColor='aqua' />
                )}
                {coverageType === 'pro' && !covered && (
                  <FreeWithPuzzlePro
                    fontColor='aqua'
                    fontFamily='space'
                    onGetProClicked={onGetProClicked}
                  />
                )}
              </VStack>
            );
          }
        })()}
      </VStack>
    </HStack>
  );
};
